<template>
  <div class="edit-result-wrapper">
    <div class="pic-content"><img src="../../assets/images/su@2x.png"/></div>
    <p class="title">恭喜您已绑定成功！</p>
    <div class="btn-style1">
      <p class="btn" @click="toImproveInfo">确定</p>
    </div>
  </div>

</template>

<script>
  import wx from 'weixin-js-sdk'
  export default {
    data(){
      return {
      }
    },
    created(){
    },
    methods: {
      toImproveInfo(){
        wx.closeWindow();
      }
    }
  }
</script>

<style scoped lang="scss">
  .edit-result-wrapper{
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    padding-top: 66px;
    .pic-content{
      width: 100%;
      text-align: center;
      @include flex;
      @include justify-content(center);
      img{
        width: 80px;
        height: 80px;
      }
    }
    .title{
      text-align: center;
      color: #333333;
      font-size: 16px;
      margin-top: 10px;
    }
    .tips{
      width: 100%;
      box-sizing: border-box;
      padding: 0 40px;
      font-size: 14px;
      color: #999999;
      text-align: center;
      margin-top: 15px;
      line-height: 18px;
    }
    .btn-style1{
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      height: 45px;
      margin-top: 45px;
      .btn{
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        border-radius: 23px;
        font-size: 16px;
        background-color: #41B7A7;
        color: #ffffff;
        letter-spacing: 1px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/goBind/editResult.vue